/**
 * Routes
 *
 */
import React from 'react'
import { Router, Route, Switch } from 'react-router'
import { ConnectedRouter } from 'connected-react-router'
import { realTimePrefix, inProduction, servingFromRealTime } from './Env'

import Dashboard from './pages/Dashboard'
import Auth from './pages/Auth'
import Registro from './pages/Registro'
import Preferencias from './pages/Preferencias'
// import Cotizaciones from './pages/Com/cotizaciones'
import Cotizacion from './pages/Com/Cotizacion'
import Ordenes from './pages/Com/ordenes'
import Entregas from './pages/Com/entregas'
import RentaEquipos from './pages/Com/renta-equipos'
import ComplementosPago from './pages/Com/complementos-pago'
import Entradas from './pages/Alm/entradas'
import PagosSolicitados from './pages/common/pagosSolicitados'
import PagosRecibidos from './pages/Tes/pagosRecibidos'
import Sub from './pages/Sub'
import Avances from './pages/Sub/Avances'
import NotFound from './pages/NotFound'

const prefix = inProduction && servingFromRealTime ? realTimePrefix : ''
export const buildPath = path => prefix + path
const inDev = process.env.NODE_ENV === 'development'

export default ({ history }) => (
  <ConnectedRouter history={history}>
    <Router history={history}>
      <Switch>
        <Route exact path={buildPath('/')} component={Dashboard} />
        <Route exact path={buildPath('/auth')} component={Auth} />
        <Route exact path={buildPath('/registro')} component={Registro} />
        <Route exact path={buildPath('/preferencias')} component={Preferencias} />
        {/* <Route exact path={buildPath('/com/cotizaciones')} component={Cotizaciones} /> */}
        <Route exact path={buildPath('/com/cotizacion/:id')} component={Cotizacion} />
        <Route exact path={buildPath('/com/ordenes')} component={Ordenes} />
        <Route exact path={buildPath('/com/entregas')} component={Entregas} />
        <Route exact path={buildPath('/com/control-rentas')} component={RentaEquipos} />
        <Route exact path={buildPath('/com/complementos-pago')} component={ComplementosPago} />
        <Route exact path={buildPath('/alm/entradas')} component={Entradas} />
        <Route exact path={buildPath('/cxp/pagos-solicitados')} component={PagosSolicitados} />
        <Route exact path={buildPath('/cxp/pagos-programados')} component={PagosRecibidos} />
        <Route exact path={buildPath('/sub/contratos')} component={Sub} />
        {inDev && <Route exact path={buildPath('/sub/contratos/:codigo')} component={Avances} />}

        <Route path={buildPath('/*')} component={NotFound} />
      </Switch>
    </Router>
  </ConnectedRouter>
)
